import _ from 'lodash';
import FBAPI from '../FBAPI';
import { SortASC } from '../../utilities/Sorting';
import InstrumentDetails from '../objects/InstrumentDetails';

// Required as our current android webview does not support native Promise.allSettled
Promise.allSettled = Promise.allSettled || function (promises) {
    const mappedPromises = promises.map((p) => {
        return p
            .then((value) => {
                return {
                    status: 'fulfilled',
                    value,
                };
            })
            .catch((reason) => {
                return {
                    status: 'rejected',
                    reason,
                };
            });
    });

    return Promise.all(mappedPromises);
};

const instruments = {
    getDetails: async (instrumentIds = []) => {
        const promises = instrumentIds.map((instrument) => {
            return FBAPI.instrumentDetails(instrument);
        });

        const response = await Promise.allSettled(promises);

        const instrumentResults = response.filter(({ value }) => value?.payload?.data)
            .map(({ value }) => new InstrumentDetails(value?.payload?.data));

        return SortASC(instrumentResults, 'instrumentId');
    },

    getInstruments: async (inputValue, limit, instrumentTypes) => {
        const response = await FBAPI.getInstruments(inputValue, limit);

        if (response?.payload?.data == null || !Array.isArray(response?.payload?.data)) {
            throw new Error('Invalid response body.');
        }

        let data = response?.payload?.data;

        if (_.isEmpty(instrumentTypes) === false) {
            data = data?.filter((item) => instrumentTypes?.includes(item.type));
        }

        return data?.map((instrument) => new InstrumentDetails(instrument));
    },
};

export default instruments;
